import React, { Component } from 'react';

class HotelOffersSkeleton extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="row">
        {
          Array.from(Array(6).keys()).map((i) => {
            return (
              <div className="col-12 col-lg-6 mb-4 px-2 px-lg-3" key={i}>
                <div className="single-room-wrapper skeleton">
                  <div className="preview-images">
                    <div className="featured-image position-relative skeleton-shine" />
                  </div>
                  <div className="room-info">
                    <div className="name mb-1 skeleton-shine" />
                    <div className="description mb-4 skeleton-shine" />
                    <div className="price skeleton-shine" />
                  </div>
                </div>
              </div>
            );
          })
        }
      </div>
    );
  }
}

export default HotelOffersSkeleton;



// WEBPACK FOOTER //
// ./scripts/components/HotelOffersSkeleton/HotelOffersSkeleton.js